/**
 * Given an array of table row data, a field to sort by, a field value, and
 * a direction, returns a new array with the data sorted.
 *
 * @param {array} rows - The array of row data to be sorted.
 * @param {string|number} field - The field to sort by.
 * @param {string} direction - Either 'ASC' or 'DESC'.
 */
export default function sortRowsByField(rows, field, direction) {
  const sortMultiplier = 'ASC' === direction ? 1 : - 1;
  // Make a deep copy of the rows array to avoid side effects.
  const newRows = rows.map((row) => ({ ...row }));

  newRows.sort((itemA, itemB) => {
    // Doctor name
    if ('NAME' === field) {
      const nameA = `${itemA.nml} ${itemA.nmf} ${itemA.nmm}`;
      const nameB = `${itemB.nml} ${itemB.nmf} ${itemB.nmm}`;
      return nameA.localeCompare(nameB) * sortMultiplier;
    } else if ('RATE' === field) { // Pills per patient
      return (itemA.rt - itemB.rt) * sortMultiplier;
    }
    // Patients filing
    return (itemA.pt - itemB.pt) * sortMultiplier;
  });

  return newRows;
}
